import React, { Component } from 'react';
import { EconomicalScoreTrackerPlayer } from '../stateless/eco-score-player';
import { connect } from 'react-redux';
import { buildAvatar } from '../../helpers';
import { players } from '../../constants/images';
import arrow from '../../../assets/images/svgs/icons/arrow_down.svg';

/**
 * @class EconomicalScoreTracker
 *
 * @description
 * Class for.
 *
 * @example
 * <EconomicalScoreTracker />
 */
@connect(
	state => {
		const avatar = state.results.saveState ? state.results.saveState.avatar : { options: [] };
		return {
			step: state.step,
			results: state.results,
			avatarOptions: avatar && avatar.options ? avatar.options : null
		}
	}
)
export default class EconomicalScoreTrackerFourPlayer extends Component {

	static propTypes = {};

	static defaultProps = {};

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);
	}

	poolVal (currentValue, unit, multiplier) {
		let poolVal = (currentValue * multiplier) || 0;

		if (unit === '$' && unit === '€') {
			poolVal = `€${poolVal}`
		} else {
			poolVal = `${poolVal}${unit}`
		}

		return poolVal;
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { currentValue, window, unit, multiplier = 1, isTime = false, poolName = 'Pot' } = this.props;

		const max = (window.current && window.current.answers && window.current.answers.range) ? window.current.answers.range.max : null;
		const playerAvatar = buildAvatar(this.props, false);
		const yourScore = isTime ? ((max - currentValue) * 100) : (currentValue * -1);

		return (max) ? (
			<div className={'eco-score-tracker__standard'}>
				<div className={'eco-score-tracker__standard__group-wrap'}>
					<EconomicalScoreTrackerPlayer score={yourScore}
																				unit={unit}
																				imgSrc={playerAvatar} />
					<EconomicalScoreTrackerPlayer score={'?'}
																				unit={unit}
																				imgSrc={players['player-2']} />
					<EconomicalScoreTrackerPlayer score={'?'}
																				unit={unit}
																				imgSrc={players['player-3']} />
					<EconomicalScoreTrackerPlayer score={'?'}
																				unit={unit}
																				imgSrc={players['player-4']} />
				</div>

				<img className={'eco-arrow'} src={arrow} />

				<div className={'eco-pool'}>
					<span>{poolName}</span>
					{this.poolVal(currentValue, unit, multiplier)} + ?
				</div>

				<img className={'eco-arrow'} src={arrow} />

				<div className={'eco-score-tracker__standard__group-wrap'}>

					<EconomicalScoreTrackerPlayer score={25}
																				unit={'%'}
																				imgSrc={playerAvatar} />
					<EconomicalScoreTrackerPlayer score={25}
																				unit={'%'}
																				imgSrc={players['player-2']} />
					<EconomicalScoreTrackerPlayer score={25}
																				unit={'%'}
																				imgSrc={players['player-3']} />
					<EconomicalScoreTrackerPlayer score={25}
																				unit={'%'}
																				imgSrc={players['player-4']} />
				</div>
			</div>
		) : null;
	}
}
